import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ringDashOffset, RING_CIRCUMFERENCE } from '../../utils/ringProgress';

interface AvailabilityRingProps {
  pct: number;
  isOpen: boolean;
  onToggle: () => void;
  label?: string;
}

export function AvailabilityRing({ pct, isOpen, onToggle, label }: AvailabilityRingProps) {
  const { t } = useTranslation();
  const displayLabel = label ?? `${pct}%`;

  return (
    <button
      type="button"
      onClick={e => {
        e.stopPropagation();
        onToggle();
      }}
      aria-expanded={isOpen}
      aria-label={t('calendar.slot.showWhoIsFree')}
      className={`relative h-[58px] w-[58px] shrink-0 rounded-full border-none bg-transparent p-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-room-accent ${isOpen ? 'open' : ''}`}
    >
      <svg
        className="block h-[58px] w-[58px] -rotate-90"
        viewBox="0 0 58 58"
        aria-hidden
      >
        <circle
          className="fill-none stroke-room-surface-3"
          cx="29"
          cy="29"
          r="25"
          strokeWidth="6"
        />
        <circle
          className="fill-none stroke-room-accent"
          cx="29"
          cy="29"
          r="25"
          strokeWidth="6"
          strokeLinecap="round"
          strokeDasharray={RING_CIRCUMFERENCE}
          strokeDashoffset={ringDashOffset(pct)}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center font-mono text-[13px] font-bold">
        {displayLabel}
      </div>
      <span className="absolute -bottom-[3px] left-1/2 flex h-[17px] w-[17px] -translate-x-1/2 items-center justify-center rounded-full border border-room-border-strong bg-room-surface-3">
        <ChevronDown
          size={9}
          strokeWidth={3}
          className={`text-room-text-dim transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </span>
    </button>
  );
}
